import React from 'react'
import { CursorClick, Users } from '@phosphor-icons/react'
import { useDiscountForm } from '../../hooks/useDiscountForm'
import UsageLimitPopover from './UsageLimitPopover'
import { DiscountPrerequisite, DiscountFieldPaths } from 'src/lib/types/discountsV2'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountUsageLimitsV2 = () => {
  const {
    state: { prerequisite, errors },
    actions: { setFormState }
  } = useDiscountForm()
  const { t } = useLocale()

  const { usageLimit } = prerequisite
  const { maxApplicableCount, maxApplicablePerUserCount } = usageLimit

  const handleTotalUsesChange = (value: number | null) => {
    setFormState(
      {
        prerequisite: {
          ...prerequisite,
          type: prerequisite.type,
          usageLimit: { ...usageLimit, maxApplicableCount: value ?? undefined }
        } as DiscountPrerequisite
      },
      [DiscountFieldPaths.MAX_APPLICABLE_COUNT]
    )
  }

  const handlePerUserUsesChange = (value: number | null) => {
    setFormState(
      {
        prerequisite: {
          ...prerequisite,
          type: prerequisite.type,
          usageLimit: { ...usageLimit, maxApplicablePerUserCount: value ?? undefined }
        } as DiscountPrerequisite
      },
      [DiscountFieldPaths.MAX_APPLICABLE_PER_USER_COUNT]
    )
  }

  return (
    <>
      <UsageLimitPopover
        value={maxApplicableCount ?? null}
        onChange={handleTotalUsesChange}
        label='total-usage'
        triggerPrefix={t('discounts_v2.can_be_used')}
        icon={CursorClick}
        error={errors[DiscountFieldPaths.MAX_APPLICABLE_COUNT]}
      />

      <UsageLimitPopover
        value={maxApplicablePerUserCount ?? null}
        onChange={handlePerUserUsesChange}
        label='per-user-usage'
        triggerPrefix={t('discounts_v2.each_shopper_can_use')}
        icon={Users}
        error={errors[DiscountFieldPaths.MAX_APPLICABLE_PER_USER_COUNT]}
      />
    </>
  )
}

export default DiscountUsageLimitsV2
